import { render, staticRenderFns } from "./TalentPool.vue?vue&type=template&id=74bf0da7&scoped=true&"
import script from "./TalentPool.vue?vue&type=script&lang=js&"
export * from "./TalentPool.vue?vue&type=script&lang=js&"
import style0 from "./TalentPool.vue?vue&type=style&index=0&id=74bf0da7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf0da7",
  null
  
)

export default component.exports